/**
 * Loads the NOAA ENC cell manifest into the chart-sources store so the real US
 * cells appear in the chart list (for the "pick a chart, jump there" flow),
 * mirroring BsbManifestLoader. Re-checks when the chart provider changes, so
 * selecting "NOAA ENC (US)" picks up cells added since startup. No manifest yet =
 * empty set, no error.
 */
import { useEffect } from 'react';
import { loadNoaaManifest } from '@/chart-sources';
import { useChartSourcesStore } from '@/store/chartSources';
import { useChartPlotterStore } from '@/store';

export function NoaaManifestLoader() {
  const setNoaaCharts = useChartSourcesStore((s) => s.setNoaaCharts);
  const chartProviderId = useChartPlotterStore((s) => s.chartProviderId);
  useEffect(() => {
    let live = true;
    loadNoaaManifest().then((charts) => {
      if (!live) return;
      const cur = useChartSourcesStore.getState();
      if (charts.length > 0 || !cur.noaaLoaded) setNoaaCharts(charts);
    });
    return () => {
      live = false;
    };
  }, [setNoaaCharts, chartProviderId]);
  return null;
}
